export default "__VITE_ASSET__825da1bc__"